module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA9.47d2fdc4.jpg";